export const splitFullName = (name?: string) => {
  if (!name) return { firstName: '', lastName: '' }

  const splitName = name.split(' ')
  const firstName = splitName[0]
  const lastName = splitName.slice(1).join(' ')
  return { firstName, lastName }
}
